import * as actions from './noteActions';

const initialState = {
  notes: [],
  selectedNote: null,
  loading: false,
  error: null,
  success: null,
};

export default function noteReducer(state = initialState, action) {
  switch (action.type) {
    // CREATE NOTE
    case actions.CREATE_NOTE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.CREATE_NOTE.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: [action.payload.data, ...state.notes],
        success: 'Note created successfully',
      };
    case actions.CREATE_NOTE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UPDATE NOTE
    case actions.UPDATE_NOTE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.UPDATE_NOTE.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: state.notes.map((note) =>
          note.id === action.payload.data.id ? action.payload.data : note
        ),
        selectedNote: action.payload.data,
        success: 'Note updated successfully',
      };
    case actions.UPDATE_NOTE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // DELETE NOTE
    case actions.DELETE_NOTE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
      };
    case actions.DELETE_NOTE.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: state.notes.filter((note) => note.id !== action.payload.noteId),
        selectedNote: null,
        success: 'Note deleted successfully',
      };
    case actions.DELETE_NOTE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET NOTES BY ORGANIZATION
    case actions.GET_NOTES_BY_ORGANIZATION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_NOTES_BY_ORGANIZATION.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.payload.data,
      };
    case actions.GET_NOTES_BY_ORGANIZATION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET NOTES BY BATCH
    case actions.GET_NOTES_BY_BATCH.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_NOTES_BY_BATCH.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.payload.data,
      };
    case actions.GET_NOTES_BY_BATCH.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET NOTES BY STAGE
    case actions.GET_NOTES_BY_STAGE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_NOTES_BY_STAGE.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.payload.data,
      };
    case actions.GET_NOTES_BY_STAGE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET NOTES BY DATE
    case actions.GET_NOTES_BY_DATE.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_NOTES_BY_DATE.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.payload.data,
      };
    case actions.GET_NOTES_BY_DATE.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // GET NOTES BY TAGS
    case actions.GET_NOTES_BY_TAGS.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_NOTES_BY_TAGS.SUCCESS:
      return {
        ...state,
        loading: false,
        notes: action.payload.data,
      };
    case actions.GET_NOTES_BY_TAGS.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // UI STATE
    case actions.SET_SELECTED_NOTE:
      return {
        ...state,
        selectedNote: action.payload,
      };

    case actions.CLEAR_NOTES:
      return {
        ...state,
        notes: [],
      };

    case actions.RESET_NOTES_STATE:
      return initialState;

    default:
      return state;
  }
}
